import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export default function Popup({
  title,
  content,
  open,
  setOpen,
  action,
  actionText,
}: {
  title: string;
  content: string;
  open: boolean;
  action: () => void;
  actionText: string;
  setOpen: (open: boolean) => void;
}) {
  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            action();
            setOpen(false);
          }}
        >
          {actionText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
